// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"65a4e78a","178":"af9921c1","717":"97c2bc86","866":"563b4b96"}[chunkId] + ".chunk.js";
};